import { useState } from "react";

// BugReportButton.jsx — render this at the root of your app, outside any modal containers
export default function BugReportButton({
    onReport
}: {
    onReport: () => any;
}) {

    const [loading, setLoading] = useState(false);
    const handleOnReport = async () => {        
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 3000);
        await onReport();
    }
    const className = loading ? 
        'fa-solid fa-spinner fa-spin-pulse text-success' : 
        'fa-solid fa-bug text-danger';

    return (
        <div
            onClick={loading ? () => {} : handleOnReport}
            style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                zIndex: 9999,          // above modals (typically 1050-1060)
                cursor: 'pointer',
                backgroundColor: '#fff',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            }}
            title="Report Issue"
        >
            <i className={className} style={{ fontSize: '20px' }} />
        </div>
    );
}